document.addEventListener('DOMContentLoaded', () => {
  if (window.nordiclyxStorefront) return;
  window.nordiclyxStorefront = true;

  const headerWrapper = document.querySelector('.header-wrapper');
  const headerEl = document.querySelector('.header');

  if (headerWrapper && headerEl) {
    window.addEventListener(
      'scroll',
      () => {
        if (window.innerWidth >= 990) {
          if (window.scrollY > 150) {
            if (!headerWrapper.style.minHeight) {
              headerWrapper.style.minHeight = `${headerWrapper.offsetHeight}px`;
            }
            headerEl.classList.add('custom-sticky-menu');
          } else {
            headerEl.classList.remove('custom-sticky-menu');
            headerWrapper.style.minHeight = '';
          }
        }
      },
      { passive: true }
    );
  }

  document.querySelectorAll('.header__inline-menu details').forEach((detail) => {
    detail.addEventListener('mouseenter', () => {
      if (window.innerWidth < 990) return;
      detail.setAttribute('open', '');
      const summary = detail.querySelector('summary');
      if (summary) summary.setAttribute('aria-expanded', 'true');
    });

    detail.addEventListener('mouseleave', () => {
      if (window.innerWidth < 990) return;
      detail.removeAttribute('open');
      const summary = detail.querySelector('summary');
      if (summary) summary.setAttribute('aria-expanded', 'false');
    });
  });

  const sourceId = 'nordiclyx-cart-shipping-source';
  let refreshing = false;
  let refreshQueued = false;

  const mountShippingBar = () => {
    const source = document.getElementById(sourceId);
    const header = document.querySelector('#CartDrawer .drawer__header');
    if (!header) return;

    const next = source ? source.querySelector('.cart-drawer__free-shipping') : null;
    const existing = header.querySelector('.cart-drawer__free-shipping');

    if (!next) {
      if (existing) existing.remove();
      return;
    }

    if (existing && existing.dataset.signature === next.innerHTML) return;
    if (existing) existing.remove();
    const clone = next.cloneNode(true);
    clone.dataset.signature = next.innerHTML;
    header.appendChild(clone);
  };

  const refreshShippingSource = () => {
    const source = document.getElementById(sourceId);
    if (!source || refreshing) {
      refreshQueued = Boolean(source);
      mountShippingBar();
      return;
    }

    const sectionId = source.dataset.sectionId;
    if (!sectionId) {
      mountShippingBar();
      return;
    }

    refreshing = true;
    fetch(`${window.location.pathname}?section_id=${sectionId}`)
      .then((response) => response.text())
      .then((html) => {
        const fresh = new DOMParser().parseFromString(html, 'text/html').getElementById(sourceId);
        const current = document.getElementById(sourceId);
        if (fresh && current) current.replaceWith(fresh);
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        refreshing = false;
        mountShippingBar();
        if (refreshQueued) {
          refreshQueued = false;
          refreshShippingSource();
        }
      });
  };

  const drawer = document.querySelector('cart-drawer');
  if (drawer) {
    const observer = new MutationObserver(() => {
      if (refreshing) return;
      mountShippingBar();
    });
    observer.observe(drawer, { childList: true, subtree: true });
    mountShippingBar();
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
      refreshShippingSource();
    });
  }
});
